import { createClient as createSupabaseClient } from '@supabase/supabase-js'
import type { SupabaseClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

/** A Supabase client typed against the full generated project schema. */
export type TomaticClient = SupabaseClient<Database>

/**
 * Create the project-typed Supabase client.
 *
 * Accepts `string | undefined` so apps can pass `import.meta.env.*` values
 * straight through; the runtime guard lives here instead of being copy-pasted
 * into every app's `lib/supabase.ts`.
 */
export function createClient(
  url: string | undefined,
  anonKey: string | undefined,
): TomaticClient {
  if (!url || !anonKey) {
    throw new Error('Missing Supabase environment variables')
  }
  return createSupabaseClient<Database>(url, anonKey)
}
